import { cssInterop } from "nativewind";
import { Image, Pressable, ScrollView, Text, TextInput, View } from "react-native";

// Enable className support for React Native Web components
cssInterop(View, { className: "style" });
cssInterop(Text, { className: "style" });
cssInterop(Image, { className: "style" });
cssInterop(TextInput, { className: "style" });
cssInterop(ScrollView, { className: "style" });
cssInterop(Pressable, { className: "style" });
